<nz-header>
  <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'" (click)="onChangeCollapse()"></i>
</nz-header>
